export default "__VITE_ASSET__CF258OBu__"